if ($('form.boxup').length) {

    if($(html).attr('lang') == 'ru') {
        window.lang_video_manager = {
            recent: 'Недавние',
            insert: '👇Вставить видео',
            delete: 'Удалить',
            download: 'Скачать',
            change: 'Изменить обложку',
            move: 'Переместить в другую папку',

            select_dir: 'Выберите папку',
            upload_error: 'Здравствуйте. При загрузке видео произошли технические проблемы, перезагрузите страницу и попробуйте снова!',
            video_broken: 'Видео повреждено!',
            video_broken_text: 'Пожалуйста, загрузите другое видео',
            reload: 'Перезагрузить',
            create_dir: 'Создать папку',

            confirm_delete: 'Удалить?',
            delete_error: 'Нельзя удалить эту папку',

            insert_filename: 'Введите имя файла',
            file_error: 'Неверный формат!',
            file_error_text: 'Можно загрузить только изображение',

            insert_dirname: 'Имя новой папки?',
        }
    }else{
        window.lang_video_manager = {
            recent: 'Recent',
            insert: '👇Insert video',
            delete: 'Delete',
            download: 'Download',
            change: 'Change cover',
            move: 'Move to another folder',

            select_dir: 'Select a folder',
            upload_error: 'Hello. There were technical issues while uploading the video, please refresh the page and try again!',
            video_broken: 'The video is damaged!',
            video_broken_text: 'Please upload another video',
            reload: 'Reload',
            create_dir: 'Create folder',

            confirm_delete: 'Delete?',
            delete_error: 'This folder cannot be deleted',

            insert_filename: 'Enter file name',
            file_error: 'Invalid format!',
            file_error_text: 'Only images can be uploaded',

            insert_dirname: 'Name of the new folder?',
        }
    }

    window.cu_editor = '';
    window.current_folder = lang_video_manager.recent;
    window.videos = {};
    window.folders_list = [];
    window.files_ipl = {};
    window.queue_upl = [];
    window.delay_upl = 0;
    window.run_ulp = 0;
    function setEditor(editor) {
        this.editor = editor;
    }

    function saveUplFile(obj) {
        console.log('saveUplFile' , obj)

        $.ajax({
            url: window.location.origin + '/video_manager/video_save/',
            method: 'post',
            data: {
                video_file: obj,
                folder: window.current_folder,

            },
            success: function (response) {
                addVideoToView(obj, response.new_id, obj.filename, response.ffile_dadd, false);
                rq();
            },
            error: function () {
                rq();
                console.log('video not save');
            }
        });
    }

    function addVideoToView(obj , ffile_id, ffile_name, ffile_dadd, load = true) {
        let locale = $('html').attr('lang');

        let res = lang_video_manager.insert;
        let d = lang_video_manager.delete;
        let dd = lang_video_manager.download;
        let ddd = lang_video_manager.change;
        let dddd = lang_video_manager.move;


        let htmll = '  <div data-ffile_id="'+ffile_id+'" id="'+obj.videoId+'" class="file-item"\n' +
            '                                                         style="position: relative;height: auto;"><img id="img-prev"' +
            '                                                                src="'+ obj.src + '?v='+Math.random()+'">\n' +
            '                                                        <div id="fname" data-filename=".mp4"\n' +
            '                                                             contenteditable="false"\n' +
            '                                                             class="titles-text"\n' +
            '                                                             id=".mp4">\n' +
            '                                                            '+ ffile_name +
            '                                                        </div>\n' +
            '                                                        <div class="file-create-data"> '+ ffile_dadd +
            '                                                        </div>\n' +
            '                                                        <div class="bottom-panel">\n' +
            '                                                            <button class="btn btn-cancel text-left btn-sm file-action action-remove"\n' +
            '                                                                    title="'+d+'"><i class="fa fa-trash" aria-hidden="true"></i>\n' +
            '                                                            </button>\n' +
            '                                                            <a class="btn btn-download file-action"\n' +
            '                                                              target="_blank"    href="/video/' + obj.videoId + '/max.mp4"  title="'+dd+'" style="    color: #212529;"><i class="fa fa-cloud-download" aria-hidden="true"></i>\n' +
            '                                                            </a>\n' +
            '                                                            <button class="btn btn-change-video-preview file-action action-preview"\n' +
            '                                                                    title="'+ddd+'"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>\n' +
            '                                                            </button>\n' +
            '                                                            <button class="btn btn-sm btn-move-file file-action action-move"\n' +
            '                                                                    title="'+dddd+'">\n' +
            '                                                                <i class="fa fa-files-o" aria-hidden="true"></i> </span>\n' +
            '                                                            </button>\n' +
            getFolderSelectMove() +
            '                                                        </div>\n' +
            '            <div class="bottom-panel btins" style="display:none;">' +
            '                          <a style="user-select: none;color: #fff; background: #09863e; border: 1px solid #09863e;font-size: 12pt;text-decoration: none;padding: 0px 10px 10px 0px;" href="javascript:void(0)" hidefocus="true" class="form-control w-100 pasteVideoFromManager" role="button"><span class="cke_dialog_ui_button">'+res+'</span></a>' +
            '                                       </div>'+
            '                                                    </div>';

        if(load) {
            $('.files-list #ll').append(htmll);
        } else {
            $('.files-list #ll').prepend(htmll);
        }



            $('div.files-number span').html(parseInt($('div.files-number span').html()) + 1) ;
            addInsertButton(obj);

    }


    function getFolderSelectMove() {
        let res = lang_video_manager.select_dir;
        let out = '<select class="form-control folder_name_copy" style="display: none"> <option selected disabled>'+res+'</option>';
        $.each(window.folders_list, function (i, folds) {
            if(folds == window.current_folder) {
                return;
            }

            out += '<option value="'+folds+'">'+folds+'</option>';
        });

        out += '</select>';
        return out;
    }

    function updateFolderSelectMove() {
        $('.folder_name_copy').find('option:not(:first)').remove();
        $.each($('.folder_name_copy'), function (i, sele) {
            $.each(window.folders_list, function (ii, folds) {
                if(folds == window.current_folder) {
                    return;
                }
                $(sele)
                    .append('<option value="'+folds+'">'+folds+'</option>');
            });

        });

    }

    function addInsertButton(obj) {
        if(window.cu_editor && window.cu_editor !== '') {
            window.videos[obj.videoId] = obj;
         //   $('div.file-item#'+obj.videoId).append('<div class="bottom-panel btins">' +
           //     '<a style="user-select: none;color: #fff; background: #09863e; border: 1px solid #09863e;font-size: 12pt;text-decoration: none;padding: 0px 0px 10px 10px;" href="javascript:void(0)" hidefocus="true" class="form-control w-100 pasteVideoFromManager" role="button"><span class="cke_dialog_ui_button">👇 Вставить видео</span></a>' +
            //    '</div>');

            $('.btins').show();

        }
    }





    console.log('----------------')
    var $uplcv_form = $('form.boxup');
    var $input = $uplcv_form.find('input[type="file"]');


    var droppedFiles = false;

    $uplcv_form.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
    })
        .on('drop', function (e) {
            droppedFiles = e.originalEvent.dataTransfer.files;
            $uplcv_form.trigger('submit');
        });


    $input.on('change', function (e) { // when drag & drop is NOT supported
        console.log(e.target.files)
        window.delay_upl = 1000;
        $.each(e.target.files, function (i, file) {
            console.log(file)
            uploadWrapper(file)


            var is_last_item = (i == (e.target.files.length - 1));
            if(is_last_item) {
                if(window.run_ulp == 0) {
                    window.run_ulp = 1;
                    setTimeout(function () {
                        rq()
                    }, 1000);
                }

            }
        });


    });

    $uplcv_form.on('submit', function (e) {
        e.preventDefault();
        window.delay_upl = 1000;
        if (droppedFiles) {
            console.log('drop')
            $.each(droppedFiles, function (i, file) {
                console.log(file)
                uploadWrapper(file)

                var is_last_item = (i == (droppedFiles.length - 1));
                if(is_last_item) {
                    if(window.run_ulp == 0) {
                        window.run_ulp = 1;
                        setTimeout(function () {
                            rq()
                        }, 1000);
                    }
                }

            });
        }
    });


    function uploadWrapper(file) {
        let myid = Math.random().toString(36).replace(/[^a-z]+/g, '');
        startNewVideoUpload(myid, file)
        console.log('Add file to queue_upl', myid)
    }

    function removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    }


    function rq() {
        console.log('window.queue_upl.length', window.queue_upl.length)
        if(!window.queue_upl.length) {
            window.run_ulp = 0;
            return;
        }

        let cid = window.queue_upl[0];
        window.queue_upl = removeItemOnce(window.queue_upl, cid);
        if (window.upload[cid].tus == null) {
            rq();
            return;
        }
        if (window.upload[cid].tus != null) {
            window.upload[cid].tus.start();
            $("#" + cid + "_closeupload").show();
        }
    }

    let startNewVideoUpload = function (myid, file) {
        const currentMyId = myid;
        const editor = CKEDITOR.instances['course_presentation_editor'];

        window.files_ipl[currentMyId] = file;

        window.upload[currentMyId] = {
            tus: null,
            src: null,
            res: null,
            status: 'wait',
            editor: CKEDITOR.currentInstance,
            videoId: null,
            filename: null
        };
        console.log('startNewVideoUpload id: ' + currentMyId);
        console.log(window.upload[currentMyId]);

        if (window.upload[currentMyId].tus != null) {
            window.upload[currentMyId].tus.abort();
            window.upload[currentMyId].tus = null;
        }

        console.log('window.delay_upl',window.delay_upl)
        setTimeout(function () {
            console.log('window.upload[myid].tus.start()');
            $("#" + currentMyId + "_progress").show();
            //$("#" + currentMyId + "_closeupload").show();
            //window.upload[currentMyId].tus.start();

            window.queue_upl.push(currentMyId)
        }, 500);


        window.upload[currentMyId].filename = file.name;

        let ext = file.name.substr(file.name.length - 4);
        const alowedTypes = ['video/mp4', 'video/mpeg', 'video/mpg', 'video/flv', 'video/webm', 'video/MP2T', 'video/quicktime', 'video/mkv', 'video/3gpp', 'video/wmv', 'video/x-ms-wmv'];
        const alowedExt = ['.flv', '.mkv', 'webm'];


        if (alowedTypes.indexOf(file.type) === -1 && alowedExt.indexOf(ext) === -1) {
            $('.boxup .box__error').html('<div class="error" style="color:red">' + editor.lang.video2.error_type + '</div>');
            $('.boxup .box__error').show();
            return;
        }
        if (file.size > 5000 * 1048576) {
            $('.boxup .box__error').html('<div class="error" style="color:red">' + editor.lang.video2.error_size + '</div>');
            $('.boxup .box__error').show();
            return;
        }

        let address_tus, parentFrom, parentId;
        if ($('[data-tus]').length) {
            address_tus = $('[data-tus]').data('tus');
        } else {
            address_tus = "https://educate.market/tus";
        }
        if ($('[data-whash]').length) {
            parentFrom = location.href + '/' + $('[data-whash]').data('whash');
        } else {
            parentFrom = location.href;
        }

        if ($('meta[name="courseId"]').length > 0)
            parentId = $('meta[name="courseId"]').attr('content');
        else if ($('meta[name="webinarId"]').length > 0)
            parentId = $('meta[name="webinarId"]').attr('content');
        else if ($('meta[name="landingId"]').length > 0)
            parentId = $('meta[name="landingId"]').attr('content');

        var options = {
            endpoint: address_tus,
            chunkSize: 5242880,
            retryDelays: [0, 3000, 5000, 10000, 20000, 60000],
            parallelUploads: 1,
            metadata: {
                filename: file.name.replace(" ", "-").replace("#", "").replace(/[^0-9a-zA-Z.]/g, ''),
                filetype: file.type,
                from: parentFrom,
                fromid: parentId,
            },
            currentMyId: currentMyId,
            onError: function (error, b, c) {
                console.log(error);
                console.log(error.originalRequest);
                console.log('eerrr', error.originalRequest);

                if (window.upload[currentMyId].tus != null) {
                    window.upload[currentMyId].tus.abort();
                    window.upload[currentMyId].tus = null;
                    window.upload[currentMyId].status = false;
                }

                $("#muploadBlock_" + currentMyId).remove();
                window.queue_upl = [];

                let res = lang_video_manager.upload_error;

                swal({
                    title: '',
                    text: res,
                    icon: "error",
                    button: "OK",
                });


            },
            onBeforeRequest: function () {

            },
            onProgress: function (bytesUploaded, bytesTotal) {
                var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2).replace('.00', '');
                //$("#upload_list #uploadBlock_" + currentMyId + " .progressBlock p").text('');
                $("#upload_list #" + currentMyId + "_progress").find('.progress-bar').attr('style', 'width:' + percentage + '%').text(percentage + '%');
                if (percentage == '100') {
                   // $("#" + currentMyId + "_closeupload").hide();
                    //$("#uploadBlock_" + currentMyId + " .progressBlock").hide();
                    //$("#" + currentMyId + "_wait").show();
                }
            },
            onSuccess: function () {
                console.log('onSuccess');

                //$("#upload_list #uploadBlock_" + currentMyId + " .progressBlock").hide();
                //$("#upload_list #" + currentMyId + "_wait").hide();


                let path = window.upload[currentMyId].tus._req._xhr.getResponseHeader('_upload_path').split(',')[0],
                    filename = window.upload[currentMyId].tus._req._xhr.getResponseHeader('_upload_name').split(',')[0],
                    videoId = window.upload[currentMyId].tus._req._xhr.getResponseHeader('_video_id').split(',')[0];


                setTimeout(function () {
                    //add video id to storage for delete ignore
                    let videoLoadsArray = localStorage.getItem('VideoLoads_' + parentId);
                    if (videoLoadsArray === null) videoLoadsArray = [];
                    else videoLoadsArray = JSON.parse(videoLoadsArray);

                    console.log(videoLoadsArray);
                    videoLoadsArray.push(videoId);
                    localStorage.setItem('VideoLoads_' + parentId, JSON.stringify(videoLoadsArray));
                }, 3500);

                let frame_1 = path + '/' + filename.split('.')[0] + '-frame-1.jpg';

                $.get(frame_1)
                    .done(function () {

                        $('div').remove('#muploadBlock_' + currentMyId);

                        console.log('window.upload[currentMyId].abort()');
                        window.upload[currentMyId].tus.abort();
                        window.upload[currentMyId].tus = null;
                        window.upload[currentMyId].status = true;
                        window.upload[currentMyId].videoId = videoId;
                        window.upload[currentMyId].size = file.size;
                        window.upload[currentMyId].filename_disk = filename;


                        $.get("/video/" + videoId + "/meta.json")
                            .done(function (data) {
                                window.upload[currentMyId].res = parseInt(data.res);


                                window.upload[currentMyId].src = path + '/' + filename.split('.')[0] + '-frame-1.jpg';
                                $uplcv_form.trigger("reset");
                                saveUplFile(window.upload[currentMyId]);


                            }).fail(function () { rq();  })


                    }).fail(function () {

                        $.ajax({
                            url: window.location.origin + '/video/delete',
                            method: 'post',
                            data: {video_file: path + '/' + filename},
                            success: function (response) {
                                console.log('video deleted', response);
                            },
                            error: function () {
                                console.log('video not deleted');
                            }
                        });

                        swal({
                            title: lang_video_manager.video_broken,
                            text: window.upload[currentMyId].filename + "\n\n" + lang_video_manager.video_broken_text,
                            icon: "error",
                            button: "OK",
                        });

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('#muploadBlock_' + currentMyId).offset().top - 120
                        }, 500);

                        $('div').remove('#muploadBlock_' + currentMyId);
                        rq();
                })







            }
        };

        window.upload[currentMyId].tus = new tus.Upload(file, options);



        let res = lang_video_manager.reload;


        const newBlock = '<div id="muploadBlock_' + currentMyId + '" style="    width: 95%;padding: 10px;" class="cke_reset_all uploadBlock mt-2">' +
            '<div class="progressBlock"><style>.rounded{cursor:pointer;border:2px solid #fff;}.activeThumb{border:2px solid blue; cursor: default;}</style><p>' + file.name + '</p><div class="progress" id="' + currentMyId + '_progress" style="">\n' +
            '<div class="progress-bar" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">0%</div>\n' +
            '</div></div>' +
            '<span class="button_close_upload_mbt" id="'+currentMyId+'_closeupload" style="cursor:pointer;display: none" tcup="'+currentMyId+'">'+res+'</span>' +
            '<div id="' + currentMyId + '_wait" style="display:none;"><p></p><div class="load_video uploading"><div class="loader"><div class="item-1"></div><div class="item-2"></div><div class="item-3"></div><div class="item-4"></div></div></div></div>' +
            '<div class="previewBlock" style="display: none">' +
            '<div class="row"><div class="col-12"><label class="ml-1 mb-0"> <input name="loop" type="checkbox" value="1"> <span></span> ' + editor.lang.video2.loop + '</label></div></div>' +
            '<div class="row">' +
            '<div class="col-12 col-md-4  text-center"><div class="p-2"><img src="" id="' + currentMyId + '_preview_1" class="rounded activeThumb"></div></div>' +
            '<div class="col-12 col-md-4  text-center"><div class="p-2"><img src="" id="' + currentMyId + '_preview_2" class="rounded"></div></div>' +
            '<div class="col-12 col-md-4 d-flex text-center">' +
            '<a style="user-select: none; height:30px;" href="javascript:void(0)" title="' + editor.lang.video2.custom_preview + '" hidefocus="true" class="cke_dialog_ui_button custom-preview" role="button"><span class="cke_dialog_ui_button">' + editor.lang.video2.custom_preview + '</span></a>' +
            '<div class="p-2"><img src="" id="' + currentMyId + '_preview_3" class="rounded"></div>' +
            '<form method="post" action="" enctype="multipart/form-data" id="myform">\n' +
            '        <div >\n' +
            '            <input type="file" class="file" name="file" />\n' +
            '            <input type="button" class="button" value="Upload" id="but_upload">\n' +
            '        </div>\n' +
            '    </form>' +
            '</div>' +
            '</div>' +
            '<div class="row p-2">' +
            '<a style="user-select: none;" href="javascript:void(0)"hidefocus="true" class="cke_dialog_ui_button cke_dialog_ui_button_ok w-100" role="button" id="' + currentMyId + '_pasteVideo"><span class="cke_dialog_ui_button">' + editor.lang.video2.title + '</span></a>' +
            '</div>' +
            '</div>' +
            '</div>';


        var e = document.createElement('div');
        e.innerHTML = newBlock;
        $('span#upload_list').append(e)

    }


    function get_videos(folder, orderby, search) {
        $.ajax({
            url: window.location.origin + '/video_manager/video_get/',
            method: 'post',
            data: {
                folder:folder,
                orderby: orderby,
                search:search
            },
            success: function (response) {
                $('div.folder-title').html(folder);
                //$('div.files-number span').html(response.files.length) ;

                $('.files-list #ll').html('');
                $.each(response.files, function (i, ffile) {
                    addVideoToView($.parseJSON(ffile.raw_data), ffile.id, ffile.file_name, ffile.created_at, true)
                });
            },
            error: function () {
                console.log('not get files');
            }
        });
    }

    $('#exampleModal').on('shown.bs.modal', function (e) {

        $('div.files-number span').html('0') ;
        $('div.files-number span').html('0') ;
        $('input#file_search').val('');

        let locale = $('html').attr('lang');

        let res = lang_video_manager.recent;
        let crf = lang_video_manager.create_dir


        get_videos(res, 'date', '');

        $.ajax({
            url: window.location.origin + '/video_manager/folders_get/',
            method: 'post',
            data: {},
            success: function (response) {
                $('div.file-dialog-folder-selector').html('');
                $('div.file-dialog-folder-selector').html(' <div class="folder-directory-picker folder-picker-recent selected"\n' +
                    '                                                     title="'+res+'"><i class="fa fa-clock-o" aria-hidden="true"></i> '+res +
                    '                                                </div>\n' +
                    '                                                <div class="folder-directory-picker folder-picker-favorites"\n' +
                    '                                                     title="'+crf+'"><i class="fa fa-plus-circle" aria-hidden="true"></i> '+crf+
                    '                                                </div>');


                window.folders_list = [];
                $.each(response.folders, function (i, folds) {
                    window.folders_list.push(folds);
                    $('div.file-dialog-folder-selector').append('    <div class="folder-directory-picker custom-directory folder-directory-picker-folder_43556"\n' +
                        '                                                     title="'+folds+'"><i class="fa fa-folder-open" aria-hidden="true"></i>\n' +
                        '                                                    <span\n' +
                        '                                                            class="custom-directory""\n' +
                        '                                                            id="'+folds+'">'+folds+'</span>\n' +
                        '                                                </div>')
                });


                $('span#use_space').html(response.use_space);
            },
            error: function () {
                console.log('not get files');
            }
        });
    })


    $('#myModal').on('hidden.bs.modal', function (e) {
        window.cu_editor = false;
        $('.btins').hide();
    })



    $(document).on('change', '.folder_name_copy', function(e) {
        e.preventDefault();

        let ffile_ite   = $(this).parent().parent();
        let ffile_id    = $(this).parent().parent().attr('data-ffile_id');


        $.ajax({
            url: window.location.origin + '/video_manager/video_move/',
            method: 'post',
            data: {
                ffile_id:ffile_id,
                move_folder:this.value
            },
            success: function (response) {
                if(response.status) {
                    ffile_ite.hide('slow', function(){ ffile_ite.remove(); });
                    $('div.files-number span').html(parseInt($('div.files-number span').html()) - 1) ;
                }
            },
            error: function () {
                console.log('action-remove err');
            }
        });
    });




    $(document).on('change', 'select#order-by', function(e) {
        $('div.files-number span').html('0') ;
        get_videos(window.current_folder, this.value, '');
    });


    $(document).on('input', 'input#file_search', function(e) {
        if(!this.value.length) {
            $('div.files-number span').html('0') ;
            get_videos(window.current_folder, $('select#order-by').val(), this.value);
            return;
        }
        if(this.value.length < 3) {
            return;
        }
        $('div.files-number span').html('0') ;
        get_videos(window.current_folder, $('select#order-by').val(), this.value);
    });


    $(document).on('click', 'div.file-item .action-move', function(e) {
        e.preventDefault();

        let ffile_ite   = $(this).parent().parent();
        $(ffile_ite).find('.folder_name_copy').show();
    });



    $(document).on('click', 'div.delete-folder-btn', function(e) {
        e.preventDefault();


        let locale = $('html').attr('lang');

        let res = lang_video_manager.delete_error;
        let crf = lang_video_manager.confirm_delete

        if(window.current_folder == 'Недавние' || window.current_folder == 'Recent') {
            alert(res);
            return ;
        }

        if(!confirm(crf)) {
            return false;
        }

        $.ajax({
            url: window.location.origin + '/video_manager/folder_remove/',
            method: 'post',
            data: {folder_remove:window.current_folder},
            success: function (response) {
                if(response.status) {
                    $('.folder-directory-picker:contains("'+window.current_folder+'")').hide('slow');
                    $('.folder-directory-picker:eq(0)').trigger('click')
                }
            },
            error: function () {
                console.log('action-remove err');
            }
        });
    });




    $(document).on('click', 'div.file-item .action-remove', function(e) {
        e.preventDefault();



        let ffile_ite   = $(this).parent().parent();
        let ffile_id    = $(this).parent().parent().attr('data-ffile_id');

        $.ajax({
            url: window.location.origin + '/video_manager/video_remove/',
            method: 'post',
            data: {ffile_id:ffile_id},
            success: function (response) {
                if(response.status) {
                    ffile_ite.hide('slow', function(){ ffile_ite.remove(); });
                    $('div.files-number span').html(parseInt($('div.files-number span').html()) - 1) ;
                }
            },
            error: function () {
                console.log('action-remove err');
            }
        });
    });



    $(document).on('click', 'div.file-item .action-name', function(e) {
        e.preventDefault();

        let ffile_ite   = $(this).parent().parent();
        let ffile_id    = $(this).parent().parent().attr('data-ffile_id');



        let res = lang_video_manager.insert_filename;


        let new_ff_name = prompt(res);
        if(!new_ff_name.length) {
            return;
        }

        $.ajax({
            url: window.location.origin + '/video_manager/video_cname/',
            method: 'post',
            data: {
                ffile_id:ffile_id,
                new_ff_name:new_ff_name
            },
            success: function (response) {
                if(response.status) {
                    ffile_ite.find('#fname').html(new_ff_name);
                }
            },
            error: function () {
                console.log('action-remove err');
            }
        });
    });



    $(document).on('click', 'div.file-item .action-preview', function(e) {
        e.preventDefault();


        let ffile_ite   = $(this).parent().parent();
        let ffile_id    = $(this).parent().parent().attr('data-ffile_id');

        var input = document.createElement('input');
        input.type = 'file';

        input.onchange = e => {

            // getting a hold of the file reference
            var file = e.target.files[0];

            let ext = file.name.substr(file.name.length - 4);
            const alowedTypes = ['image/jpeg', 'image/jpg', 'image/webp', 'image/png'];
            const alowedExt = ['.jpg', '.webp', '.jpeg', '.png'];

            if (alowedTypes.indexOf(file.type) === -1 && alowedExt.indexOf(ext) === -1) {

                let res = lang_video_manager.file_error;
                let ress = file_error.file_error_text;

                swal({
                    title: res,
                    text: ress,
                    icon: "error",
                    button: "OK",
                });

                return;
            }



            var formData = new FormData();
            formData.append("video_preview", file, file.name);



            $.ajax({
                url: window.location.origin + '/video_manager/video_cpreview/'+ffile_id,
                method: 'post',
                contentType: false,
                processData: false,
                data: formData,
                success: function (response) {
                    if(response.status) {
                        $(ffile_ite).find('#img-prev').attr("src",$(ffile_ite).find('#img-prev').attr("src")+"?timestamp=" + new Date().getTime());
                    }
                },
                error: function () {
                    console.log('action-remove err');
                }
            });


        }

        input.click();



    });



    $(document).on('click', 'div.folder-directory-picker', function(e) {
        e.preventDefault();

        $('div.folder-directory-picker').removeClass('selected');
        $(this).addClass('selected');

        let action = $(this).attr('title');


        if(action == 'Создать папку' || action == 'Create a folder') {

            let res = lang_video_manager.insert_dirname;


            let new_folder_name = prompt(res);
            if(!new_folder_name.length) {
                return;
            }


            $.ajax({
                url: window.location.origin + '/video_manager/new_folder/',
                method: 'post',
                data: {new_folder:new_folder_name},
                success: function (response) {
                        if(response.status) {
                            $('div.file-dialog-folder-selector').append('    <div class="folder-directory-picker custom-directory folder-directory-picker-folder_43556"\n' +
                                '                                                     title="'+new_folder_name+'"><i class="fa fa-folder-open" aria-hidden="true"></i>\n' +
                                '                                                    <span\n' +
                                '                                                            class="custom-directory""\n' +
                                '                                                            id="'+new_folder_name+'">'+new_folder_name+'</span>\n' +
                                '                                                </div>')

                            window.folders_list.push(new_folder_name)
                            updateFolderSelectMove();
                        }

                },
                error: function () {
                    console.log('not get files');
                }
            });

            return;
        }

        $('div.files-number span').html('0') ;
        window.current_folder = action;
        get_videos(action, 'date', '');
    });


    $(document).on('click', '.pasteVideoFromManager', function(e) {
        e.preventDefault();


        let obg_id = $(this).parent().parent().attr('id');
        vobj = window.videos[obg_id];
        console.log(vobj);

        let  edd = window.cu_editor;

        let currentMyId = Math.random().toString(36).replace(/[^a-z]+/g, '');
        edd.insertHtml('<span id="'+currentMyId+'_preload"></span>');
        let videoElement = document.createElement('video');
        videoElement.setAttribute('class', 'editor-video-js vjs-16-9');
        videoElement.setAttribute('data-setup', '{}');
        videoElement.setAttribute('controls', '1');
        videoElement.setAttribute('volume', '0.5');
        videoElement.setAttribute('poster', vobj.src+ '?v='+Math.random());
        // videoElement.setAttribute('src', '/video/'+vobj.videoId+'/max.mp4');
        videoElement.setAttribute('src', '/s_video/' + btoa(vobj.videoId + '###' + 'max') + '/max.mp4');
        videoElement.setAttribute('data-video-id', vobj.videoId);

        let sources = '';

        let res = vobj.res;
        // if (res < 720 || res === null) sources += '<source src="/video/' + vobj.videoId + '/original.mp4" label="Original" res="' + res + '">\n';
        // if (res >= 720) sources += '<source src="/video/' + vobj.videoId + '/sd.mp4" label="720p" res="720">\n';
        // if (res >= 1080) sources += '<source src="/video/' + vobj.videoId + '/hd.mp4" label="1080p" res="1080">\n';

        if (res < 720 || res === null) sources += '<source src="/s_video/' + btoa(vobj.videoId + '###' + 'original') + '/original.mp4" label="Original" res="' + res + '">\n';
        if (res >= 720) sources += '<source src="/s_video/' + btoa(vobj.videoId + '###' + '720p') + '/sd.mp4" label="720p" res="720">\n';
        if (res >= 1080) sources += '<source src="/s_video/' + btoa(vobj.videoId + '###' + '1080p') + '/hd.mp4" label="1080p" res="1080">\n';


        videoElement.innerHTML = (sources);
        let divElement = document.createElement('div');
        divElement.setAttribute('class', 'ckeditor-html5-videojs');
        divElement.appendChild(videoElement);


        let replaced = edd.getData().replace('<span id="' + currentMyId + '_preload"></span>', divElement.outerHTML);
        if(edd.getData().indexOf('<p><span id="' + currentMyId + '_preload"></span></p>')>-1){
            replaced = edd.getData().replace('<p><span id="' + currentMyId + '_preload"></span></p>', divElement.outerHTML + '<p><br/></p>');
        }
        edd.setData(replaced);
        edd.fire('insertVideo', edd.container.find('video'));

        $('#exampleModal').modal('hide');
        window.cu_editor = false;
        $('.btins').hide();

    });


    $(document).on('click','.button_close_upload_mbt', function(){
        let dd = $(this).attr('tcup');
        window.upload[dd].tus.abort();
        window.upload[dd].tus = null;
        //window.upload[$(this).attr('tcup')].tus.start();

        $("#muploadBlock_" + dd).remove();
        window.queue_upl.push(dd);
        startNewVideoUpload(dd, window.files_ipl[dd])

            setTimeout(function () {
                rq();
            }, 1000);



    });

}
